import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";

import * as numeral from 'numeral'
import "numeral/locales/ru"

import {insertHeader} from './components/insertHeader';


// не рендерим шапку если в url есть параметр 'lk2'
const EXTERNAL_LK_ID = 'lk2';
const urlParams = new URLSearchParams(window.location.search);
const source = urlParams.get('source');

if (!source || source !== EXTERNAL_LK_ID) {
    insertHeader();
}


numeral.locale('ru');

ReactDOM.render((
    <App/>
), document.getElementById("root"));
